import { finalize, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslationService } from '@proximus/ng-common';
import { Line } from '../models/line.model';
import { Ont } from '../models/ont.model';
import { ModemChoiceService } from '../modem-choice.service';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-add-ont',
  templateUrl: './modem-choice-add-ont.component.html',
})
export class ModemChoiceAddOntComponent {
  @Input() line!: Line;
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Output() added = new EventEmitter<Ont>();
  pending = false;
  form: FormGroup<{ serialNumber: FormControl<string> }>;

  constructor(
    private fb: NonNullableFormBuilder,
    private translationService: TranslationService,
    private modemChoiceService: ModemChoiceService,
  ) {
    const serialNumberValidator = Validators.pattern(
      this.translationService.getTranslatedValueFor(
        'modem-choice.ont-serial-number-regex',
      ) as string,
    );
    this.form = this.fb.group({
      serialNumber: ['', [Validators.required, serialNumberValidator]],
    });
  }

  onAdd(): void {
    const serialNumber = this.serialNumber.value.toUpperCase();
    this.pending = true;
    this.modemChoiceService
      .addOnt(this.line.circuitId, {
        accessType: this.line.devices[0].accessType,
        serialNumber,
        utac: this.line.utac,
      })
      .pipe(
        tap((ont) => {
          this.added.emit(ont);
          this.close();
        }),
        finalize(() => (this.pending = false)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  onClose(): void {
    if (this.pending) return;
    this.close();
  }

  private close(): void {
    this.open = false;
    this.openChange.emit(false);
  }

  get serialNumber(): FormControl<string> {
    return this.form.controls.serialNumber;
  }
}
